import './globals';
import './viewer.scss';
import { VevContent } from 'vev';
import React from 'react';
import { hydrate } from 'react-dom';
import { Router, importAllWidgets, View, App, AppState, hydratePreRenderedModels } from './core';
import polyfills from './core/polyfills';
import { disabledPreload } from './core/page-resolver';

export * from './core';
export function render(content: VevContent) {
  Object.assign(AppState, content);

  const root = document.getElementById('__vev');
  if (root.tagName === 'VEVROOT') View.root = root;
  Promise.all([importAllWidgets(), polyfills()]).then(() => {
    const embed = root.hasAttribute('embed');

    Router.init(!embed);
    // If embed enabled them disable preloading of pages and set page to embed page key or index page if not found
    if (embed) {
      const page = Router.page(root.getAttribute('embed'));
      Router.set(page ? page.key : Router.indexKey);
      disabledPreload();
    }

    View.enable(content.scaling);
    hydratePreRenderedModels(root);
    hydrate(<App pageKey={Router.currentPage} />, root);
  });
}

declare const vevr: () => void;
declare const vevc: () => void;
// Check if pending vev widget register exits (window.vevr). Added by widget script if loaded before window.vev exists
if (typeof vevr !== 'undefined') setTimeout(vevr, 0);
// Check if pending vev content render exits (window.vevr). Added by content script if loaded before window.vev exists
if (typeof vevc !== 'undefined') setTimeout(vevc, 0);
